import React from 'react';

// MUI Components
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

const ConfirmModal = ({ open, setOpen, title, message, onConfirm, onCancel }) => {

    const handleClose = () => {
        setOpen(false);
        onCancel();
    }

    return (
        <Dialog open={open} onClose={() => setOpen(false)}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>{message}</DialogContent>
            <DialogActions>
                <Button variant='contained' color='error' onClick={handleClose}>Cancel</Button>
                <Button variant='contained' color='primary' onClick={onConfirm}>Confirm</Button>
            </DialogActions>
        </Dialog>
    );
    
}

export default ConfirmModal;